var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ElementRef, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { config } from '../../../../config/config';
import { CreatePlaceCommand } from '../../../commands/hub/place/create.place.command';
import { BaseComponent } from '../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../common/components/success.wrap/success.wrap.component';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { ModalService } from '../../../common/services/modal.service';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { HubApiService } from '../../../services/hub.api.service';
import { EditPlaceCategoryModalActions } from '../../hub/edit.place.category.modal/edit.place.category.modal.provider';
import { EditPlaceCategoryModalComponent } from '../../hub/edit.place.category.modal/edit.place.category.modal.component';
import { HubPlace } from '../../../models/hub/hub.place';
var VisitorCreatePlaceComponent = /** @class */ (function (_super) {
    __extends(VisitorCreatePlaceComponent, _super);
    function VisitorCreatePlaceComponent(formBuilder, router, activatedRoute, modalService, imageService, hubApiService, visitorApiService) {
        var _this = _super.call(this, { activatedRoute: activatedRoute }) || this;
        _this.formBuilder = formBuilder;
        _this.router = router;
        _this.activatedRoute = activatedRoute;
        _this.modalService = modalService;
        _this.imageService = imageService;
        _this.hubApiService = hubApiService;
        _this.visitorApiService = visitorApiService;
        _this.command = new CreatePlaceCommand();
        _this.resizeImageTemp = null;
        _this.backUrl = routeConfigs.visitor.placeCalendar;
        _this.categoryText = '';
        _this.isEmailGDPRAllowed = false;
        _this.isImageChanged = false;
        _this.hasCopyrights = false;
        _this.imageUploaderLabel2 = 'Please upload images in JPG, PNG or WEBP format. Landscape images recommended';
        return _this;
    }
    VisitorCreatePlaceComponent.prototype.ngOnInit = function () {
        var _this = this;
        var hubName = this.allRouteParams.hubName;
        this.hubName = hubName;
        this.command.defaultImage = config.defaultImageUrl;
        this.createPlaceForm = this.formBuilder.group({
            name: [null, [Validators.required]],
            description: [null, []],
            address: [null, [Validators.required]],
            website: [null, []],
            category: [null, []],
            ownerEmail: [null, []],
        });
        this.visitorApiService.getPlaceCategoryToggle(this.hubName).subscribe(function (toggleCommand) {
            _this.toggles = toggleCommand.toggle;
        });
        this.activatedRoute.url.subscribe(function (data) {
            var submitPath = routeConfigs.submit.place.path.replace(':hubName/', '');
            if (data.any(function (x) { return x.path.includes(submitPath); })) {
                _this.backUrl = routeConfigs.tripPlanner.trip;
            }
        });
    };
    VisitorCreatePlaceComponent.prototype.onImageChange = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!file) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.imageService.compressImageFileToBase64(file, config.compressImgWidth)];
                    case 1:
                        _a.resizeImageTemp = _b.sent();
                        this.isImageChanged = true;
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    VisitorCreatePlaceComponent.prototype.createPlace = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var hubName, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hubName = this.allRouteParams.hubName;
                        this.command.isHubCreated = false;
                        if (!this.resizeImageTemp) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.hubApiService.uploadBase64ImageToAWS(this.resizeImageTemp)];
                    case 1:
                        res = _a.sent();
                        if (res.success) {
                            this.command.image = null;
                            this.command.imageLink = res.url;
                        }
                        _a.label = 2;
                    case 2:
                        this.visitorApiService
                            .createPlace(hubName, this.command)
                            .finally(event.complete)
                            .subscribe(function () {
                            _this.successWrap.success();
                            _this.command = new CreatePlaceCommand();
                            _this.createPlaceForm.markAsPristine();
                            _this.selectedImageData = null;
                            _this.command.category = '';
                            _this.categoryText = '';
                            _this.descriptionArea.nativeElement.style.height = '40px';
                            _this.resizeImageTemp = null;
                            _this.isImageChanged = false;
                            _this.hasCopyrights = false;
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    VisitorCreatePlaceComponent.prototype.descriptionChange = function () {
        this.descriptionArea.nativeElement.style.height =
            Math.min(this.descriptionArea.nativeElement.scrollHeight, 500) + 'px';
    };
    VisitorCreatePlaceComponent.prototype.goBack = function () {
        this.router.navigateByUrl(getRouteUrl(this.backUrl, {
            hubName: this.hubName,
            category: 'all',
        }), { skipLocationChange: this.noChangeUrlWhenRedirect });
    };
    VisitorCreatePlaceComponent.prototype.showEditCategoryModal = function () {
        var _this = this;
        var actions = {
            confirm: function (event, category) {
                _this.categoryText = category.categoryText;
                _this.command.category = category.category;
            },
        };
        this.modalService.show({
            component: EditPlaceCategoryModalComponent,
            providers: [
                { provide: EditPlaceCategoryModalActions, useValue: actions },
                {
                    provide: HubPlace,
                    useValue: {
                        hubName: this.hubName,
                        categoryText: this.categoryText,
                        category: this.command.category,
                        categoryList: this.command.category ? this.command.category.split(', ') : [],
                    },
                },
            ],
            panelClass: 'width-modal-70p',
        });
    };
    VisitorCreatePlaceComponent.prototype.canDeactivate = function () {
        if (this.createPlaceForm.pristine) {
            return Observable.of(true);
        }
        var allowNavigate = new Subject();
        this.modalService.showUnSaveWarning({ allowNavigate: allowNavigate });
        return allowNavigate;
    };
    return VisitorCreatePlaceComponent;
}(BaseComponent));
export { VisitorCreatePlaceComponent };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/visitor/create.place/create.place.component.ts.pre-build-optimizer.js